export default {
    future_releases_period: []
};